import type { FC } from 'react';
import { useRemitReportingEntrypoint } from 'src/apis/remit-reporting/use-remit-reporting-entrypoint';
import { PageSpinner } from 'src/components/spinner-container';
import Page from 'src/pages/reporting/remit-reports/page';
import { Forbidden } from 'src/utils/errors';

export const ReportingPrimaryRemitReports: FC<{}> = () => {
  const remitReportingEntrypoint = useRemitReportingEntrypoint();

  if (!remitReportingEntrypoint.loaded) return <PageSpinner />;

  if (!remitReportingEntrypoint.response?.data) throw new Forbidden();

  return <Page entrypoint={remitReportingEntrypoint.response.data} />;
};
